import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import appSelectors from '@/redux/app/appSelectors';

// Запрет скролла при открытии меню/модалки
const useBlockScroll = () => {
  const displayLoader = useSelector(appSelectors.displayLoader);
  const displayModal = useSelector(appSelectors.displayModal);

  useEffect(() => {
    if (displayLoader || displayModal) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'unset';
  }, [displayLoader, displayModal]);
};

export default useBlockScroll;
